import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FormComponent } from './form/form.component';
const routes: Routes = [
  { path: '', redirectTo: "/home", pathMatch: 'full' },
  { path: 'home',  component: HomeComponent, data: { title: 'Techpixels: Home' } },
  { path: 'form',  component: FormComponent, data: { title: 'Enquire' } },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home/itheunrealist/techpixels/src/app/app-routing.module.ts